.ui-segmented--size-middle :global(.ant-segmented-item-label) {
  font-size: var(--rc-theme-font-size-text-base);
}
